import React from 'react';

export interface BreadcrumbsItemProps {
  className?: string;
  style?: React.CSSProperties;
  href: string;
  onClick?: (e: React.MouseEvent) => void;
  children: React.ReactNode;
}

const BreadCrumbItem: React.FunctionComponent<BreadcrumbsItemProps> = () => {
  return null;
};

export default BreadCrumbItem;
